import { render, staticRenderFns } from "./ControlWorkTime.vue?vue&type=template&id=275fe390&lang=pug"
import script from "./ControlWorkTime.vue?vue&type=script&lang=js"
export * from "./ControlWorkTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports